import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ArrowRight, Mail, Users, Zap, Sparkles, FileStack, BarChartBig, Workflow, Shield } from "lucide-react";

const Hero = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="section-container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-tasktide-teal/10 text-tasktide-teal text-sm font-medium border border-tasktide-teal/20">
              <span className="h-1.5 w-1.5 rounded-full bg-tasktide-teal animate-pulse" />
              28 Products Shipping Now
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] text-white">
              Tools That
              <br />
              <span className="text-gradient">Write Themselves</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-400 max-w-lg leading-relaxed">
              We build focused AI tools for real jobs. Cold emails. Lead lists. Content drafts. 
              Contracts. Each product ships with a working backend, clean UI, and real tests. 
              A new one rolls out every hour.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button asChild className="bg-gradient-to-r from-tasktide-teal to-tasktide-blue hover:shadow-lg hover:shadow-tasktide-teal/20 text-white button-3d transition-all duration-300">
                <Link to="/projects">
                  Browse the Catalog <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" className="border-white/10 text-white hover:bg-dark-300/50 hover:text-tasktide-teal button-3d">
                <Link to="/contact">
                  Get in Touch
                </Link>
              </Button>
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-tasktide-teal/5 via-tasktide-purple/5 to-tasktide-blue/5 rounded-2xl backdrop-blur-sm border border-white/5" />
              <div className="relative glass-card rounded-xl p-6 shadow-2xl">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-dark-300/40 p-4 rounded-lg hover:bg-dark-300/60 transition-colors group">
                    <Mail className="text-tasktide-teal h-5 w-5 mb-3" />
                    <h3 className="text-sm font-semibold text-white mb-1">ColdMail AI</h3>
                    <p className="text-xs text-gray-400">Personalized outreach in seconds.</p>
                  </div>
                  <div className="bg-dark-300/40 p-4 rounded-lg hover:bg-dark-300/60 transition-colors">
                    <Users className="text-tasktide-purple h-5 w-5 mb-3" />
                    <h3 className="text-sm font-semibold text-white mb-1">Lead Qualifier</h3>
                    <p className="text-xs text-gray-400">Find and score prospects.</p>
                  </div>
                  <div className="bg-dark-300/40 p-4 rounded-lg hover:bg-dark-300/60 transition-colors">
                    <Zap className="text-tasktide-orange h-5 w-5 mb-3" />
                    <h3 className="text-sm font-semibold text-white mb-1">Sequence Writer</h3>
                    <p className="text-xs text-gray-400">Full cadences that adapt.</p>
                  </div>
                  <div className="bg-dark-300/40 p-4 rounded-lg hover:bg-dark-300/60 transition-colors">
                    <Sparkles className="text-tasktide-blue h-5 w-5 mb-3" />
                    <h3 className="text-sm font-semibold text-white mb-1">PDF Summarizer</h3>
                    <p className="text-xs text-gray-400">500 pages to summary in 60s.</p>
                  </div>
                </div>

                <div className="mt-4 p-3 rounded-lg bg-dark-300/40 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
                    <span className="text-xs text-gray-300">10 live · 8 beta · 10 building</span>
                  </div>
                  <Link to="/projects" className="text-xs text-tasktide-teal hover:text-white transition-colors">
                    See all →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;